import { render } from "./consuleBG.vue?vue&type=template&id=375d4498&scoped=true"
import script from "./consuleBG.vue?vue&type=script&lang=js"
export * from "./consuleBG.vue?vue&type=script&lang=js"

import "./consuleBG.vue?vue&type=style&index=0&id=375d4498&lang=scss&scoped=true"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d4498"]])

export default __exports__